module.exports = __webpack_public_path__ + "static/90968e362ef8bbcb330ca7c34dcb57565c6c3be3c1531eaee1f50b671b73c21c-97afe1fcdef657674d0f23a7c3e5dc60.png";